import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// IMAGES
import t1 from "../../img/c1.jpg";
import t2 from "../../img/c2.jpg";
import t3 from "../../img/c3.jpg";
import t4 from "../../img/c4.jpg";
import t5 from "../../img/c5.png";

// ICONS
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";

function Testimonial() {
    let slider1 = useRef(null);
    let slider2 = useRef(null);
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);

    useEffect(() => {
        setNav1(slider1);
        setNav2(slider2);
    }, []);

    var settings = {
        asNavFor: nav1,
        infinite: true,
        slidesToShow: 3,
        swipeToSlide: true,
        focusOnSelect: true,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div className="testimonial">
            <div className="custom-container">
                <Row>
                    <Col xs={{ span: 24 }} md={{ span: 8 }}>
                        <div className="title">
                            <h1>What Our Client Say About Us</h1>
                            <p>
                                We appricate all the love and feedbacks from our
                                clients
                            </p>
                        </div>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 16 }}>
                        <div className="testimonial__text">
                            <Slider
                                asNavFor={nav2}
                                ref={(el) => (slider1 = el)}
                            >
                                <div>
                                    <p>
                                        <FaQuoteLeft />
                                        Lorem Ipsum is simply dummy text of the
                                        printing and typesetting industry. Lorem
                                        Ipsum has been the industry's standard
                                        dummy
                                        <FaQuoteRight />
                                    </p>
                                    <h3>John Snow</h3>
                                </div>
                                <div>
                                    <p>
                                        <FaQuoteLeft />
                                        Lorem Ipsum is simply dummy text of the
                                        printing and typesetting industry. Lorem
                                        Ipsum has been the industry's standard
                                        dummy
                                        <FaQuoteRight />
                                    </p>
                                    <h3>John Snow</h3>
                                </div>
                                <div>
                                    <p>
                                        <FaQuoteLeft />
                                        Lorem Ipsum is simply dummy text of the
                                        printing and typesetting industry. Lorem
                                        Ipsum has been the industry's standard
                                        dummy
                                        <FaQuoteRight />
                                    </p>
                                    <h3>John Snow</h3>
                                </div>
                                <div>
                                    <p>
                                        <FaQuoteLeft />
                                        Lorem Ipsum is simply dummy text of the
                                        printing and typesetting industry. Lorem
                                        Ipsum has been the industry's standard
                                        dummy
                                        <FaQuoteRight />
                                    </p>
                                    <h3>John Snow</h3>
                                </div>
                                <div>
                                    <p>
                                        <FaQuoteLeft />
                                        Lorem Ipsum is simply dummy text of the
                                        printing and typesetting industry. Lorem
                                        Ipsum has been the industry's standard
                                        dummy
                                        <FaQuoteRight />
                                    </p>
                                    <h3>John Snow</h3>
                                </div>
                            </Slider>
                        </div>
                    </Col>
                    <Col xs={{ span: 24 }}>
                        <div className="testimonial__image">
                            <Slider ref={(el) => (slider2 = el)} {...settings}>
                                <div className="image-wrapper">
                                    <img src={t1} alt="" />
                                </div>
                                <div className="image-wrapper">
                                    <img src={t2} alt="" />
                                </div>
                                <div className="image-wrapper">
                                    <img src={t3} alt="" />
                                </div>
                                <div className="image-wrapper">
                                    <img src={t4} alt="" />
                                </div>
                                <div className="image-wrapper">
                                    <img src={t5} alt="" />
                                </div>
                            </Slider>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default Testimonial;
